
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class BlacklistService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/all-blacklists',query);
    }

    create(body: any) {
        return this.post('/post-blacklist',body);
    }

    update(updateBlacklist) {
        return this.put('/update-blacklist', updateBlacklist);
    }

    delete(id){
        return this.post('/delete-blacklist/'+id);
    }

    deleteMulti(body: any){
        return this.post('/delete-multi-blacklist', body);
    }

    uploadAdd(body:any){
        return this.post('/upload-add-blacklist', body);
    }

    uploadDelete(body:any){

        return this.post('/upload-delete-blacklist', body);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Blacklist.service.ts